
import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { SubjectNote } from '../../models/subject';
declare const urlize:any;

@Component({
  selector: 'app-teacher-note',
  templateUrl: './teacher-note.component.html',
  styleUrls: ['./teacher-note.component.scss']
})
export class TeacherNoteComponent implements OnInit {

  constructor() { }

  @Input('teachernotes')  teacher_note: SubjectNote
  showFullNote: boolean = false;
  lastUpdatedTime: string = null;

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.teacher_note) {
      this.teacher_note.class_notes = this.processLinks(this.teacher_note.class_notes);
      this.lastUpdatedTime = this.convertToAgoFormat(this.teacher_note.updated_date);
    }
  }

  processLinks(text: string)
  {
    return urlize(text, {nofollow:true, autoescape:true, target:'_blank'} ) 
  }

  convertToAgoFormat(time: Date){
    var date = new Date(time),
    diff = (((new Date()).getTime() - date.getTime()) / 1000),
    daydiff = Math.floor(diff / 86400);

    if (isNaN(daydiff) || daydiff < 0 || daydiff > 1){
      return null;
    }

    return daydiff == 0 && (
      diff < 60 && "Just now" ||
      diff < 120 && "1 minute ago" ||
      diff < 3600 && Math.floor(diff / 60) + " minutes ago" ||
      diff < 7200 && "1 hour ago" ||
      diff < 86400 && Math.floor(diff / 3600) + " hours ago") ||
      daydiff == 1 && "Yesterday";
  }

}
